import { z } from "zod";

export const formatString = (value: string) => {
  return `"${value.replace(/(\r\n|\n|\r|\s+|\t|&nbsp;)/gm, ' ').replace(/"/g, '""')}"`;
};


/**
 * Read through each of the lines and remove multiple line breaks in a row or if there
 * are trailing line breaks at the end of the array of lines.
 * @param lines: string[]
 * @returns string[]
 */
export const cleanMultiLines = (lines: string[]): string[] => {
  let lastLineBreak = false;
  return lines.filter((line, i) => {
    if (line.trim() === '') {
      if (lastLineBreak === true || i === lines.length - 1) {
        return false;
      } else {
        lastLineBreak = true;
      }
    } else {
      lastLineBreak = false;
    }
    return true;
  });
};

/**
 * Removes more than 2 consecutive line breaks and any beginning or trailing (line breaks, spaces, tabs, etc.)
 * @param {*} message 
 * @returns 
 */
export const cleanMessage = (message: string) => {
  return message.replace(/[\n]{2,}/g, "\n\n").trim();
};

/**
 * Helper method to convert input string to init caps,
 * which is first letter of word is upper case ane rest of letters are lower case
 * NOTE: Reusing same helper method from ODM UI, per  recommendation
 * @param inputString
 */
export const convertToTitleCase = (inputString: string) => {
   try{
    // Validate inputString using zod schema to validate any data type issues
    const result = z.string().safeParse(inputString);
    if(!result.success) return '';

    //regex to accept letters and numbers from any language, hyphen and period
    let sentence = inputString?.toLowerCase().split(/[^\p{L}\p{N}.\-']+/gu).filter(ele => ele !== '');
    for (let i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    // console.log('convertToTitleCase : returned output string is :', sentence.join(' '));
    return sentence.join(' ');
    }
    catch(err){
      console.log('convertToTitleCase: error is ', JSON.stringify(err))
      throw err;
    }
};

/**
 * Helper method to evaluate input value for null, undefined etc
 * @param value
 */
export const isValidValue = (value:any)  => {
  if (value === undefined ||
      value === null ||
      (typeof value === 'string' &&
          (value.trim().length === 0 || value.trim() === '' || value.trim().toUpperCase() === 'NULL' || value.trim().toUpperCase() === 'UNDEFINED'))
  ) {
    return false;
  }
  return true;
};
